module.exports = __webpack_public_path__ + "static/media/info-circle.b9d50999.svg";